import { useCallback } from "react";
import { useSelector } from "react-redux";

import { getActiveFolder } from "../../../../store/modules/library/selectors";
import { getUser } from "../../../../store/modules/session/selectors";

import { CreateMethod } from "../../../../api/amplitude/types";
import { createRecord, validationSchema, createArg, Message } from "../../../../utils/createRecord";

interface ISuccessCallback {
  id: string;
  title: string;
  wordCount: number;
  startTimestamp: number;
  eventData: {
    book_create_method: CreateMethod;
  };
}

interface IErrorCallback {
  message: Message | string;
  eventData?: {
    book_create_method: CreateMethod;
  };
}

export type SuccessCallback = (props: ISuccessCallback) => void;
export type ErrorCallback = (props: IErrorCallback) => void;

export const Errors: Record<Message | string, [string, string]> = {
  [Message.userRequired]: ["User", "User does not exist."],
  [Message.folderRequired]: ["Folder", "Folder does not exist."],
  [Message.databaseId]: ["Firebase", "ID not been created."],
};

export const useCreateNewRecord = (successCallback: SuccessCallback, errorCallback: ErrorCallback) => {
  const user = useSelector(getUser);
  const activeFolder = useSelector(getActiveFolder);

  return useCallback(() => {
    const startTimestamp = performance.now();

    const eventData = {
      book_create_method: CreateMethod.INPUT_TEXT,
    };

    try {
      const validData = validationSchema.validateSync({ user, activeFolder });
      const args = createArg(validData);

      createRecord(...args)
        .then((record) => {
          successCallback({ ...record, startTimestamp, eventData });
        })
        .catch(({ message }: Error) => {
          errorCallback({ message, eventData });
        });
    } catch ({ message }) {
      errorCallback({ message });
    }
  }, [user, activeFolder, successCallback, errorCallback]);
};
